/* Demontha — özellik tablosunda ölçü satırlarını sınıflandırır.
   347 ürün sayımı (2026-08): 289 üründe Yükseklik+Genişlik+Derinlik tam,
   23 üründe iki ölçü, 8'inde tek; 11 üründe İngilizce Height/Width/Depth,
   8'inde Uzunluk, 2'sinde Çap. .com tarafında etiketler İngilizce
   (Height/Width/Depth/Length/Diameter); TR anahtarlar zararsız durur.
   Eşleşme TAM etiket metni üzerinden —
   nth-child ürüne göre değişen satır sırasında yanlış satırı yakalar.
   "Oturma Yüksekliği" gibi bileşik etiketler bilerek eşleşmez.
   Bir kez çalışır; MutationObserver yok. JS çalışmazsa sınıflar oluşmaz,
   tablo bugünkü alt alta düzeninde kalır (bozulma değil, iyileştirmenin
   yokluğu). Görsel karşılığı: dmt-product-attributes.css bölüm 7. */
(function () {
  'use strict';

  var DIMS = ['height', 'width', 'depth', 'length', 'diameter',
    'yükseklik', 'yukseklik', 'genişlik', 'genislik', 'derinlik',
    'uzunluk', 'çap', 'cap'];

  function classify() {
    var tables = document.querySelectorAll(
      '.wt-product table.woocommerce-product-attributes,' +
      ' .wt-product table.shop_attributes'
    );
    for (var i = 0; i < tables.length; i++) {
      var rows = tables[i].rows;
      var count = 0;
      for (var j = 0; j < rows.length; j++) {
        var th = rows[j].querySelector('th');
        if (!th) { continue; }
        var label = (th.textContent || '').replace(/\s+/g, ' ')
          .trim().toLocaleLowerCase('en');
        if (DIMS.indexOf(label) !== -1) {
          rows[j].classList.add('dmt-dim-row');
          count++;
        }
      }
      if (count >= 2) { tables[i].classList.add('dmt-dims-on'); }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', classify);
  } else {
    classify();
  }
})();
